var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.salesProduct.length == 0)?_c('div',{staticClass:"pb-2"},[_c('not-found')],1):_c('div',{staticClass:"pr-2 mt-n2"},[_c('apexchart',{attrs:{"type":"bar","height":"310","options":_vm.chartOptions,"series":_vm.salesProduct}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }